// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__YbWWy","footer":"ModalUpdate_footer__288FU"};